import { createSlice } from '@reduxjs/toolkit';

import { getPromo } from '../../../api/promoApi';

import { IPromoState } from './IPromoState';

const initialState: IPromoState = {
  images: [],
  imagesIsLoading: false,
  imagesError: null,
};

export const promoSlice = createSlice({
  name: 'promo',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPromo.fulfilled, (state: IPromoState, action) => {
        state.images = action.payload.result.promo;
        state.imagesIsLoading = false;
        state.imagesError = null;
      })
      .addCase(getPromo.pending, (state: IPromoState) => {
        state.imagesIsLoading = true;
        state.imagesError = null;
      })
      .addCase(getPromo.rejected, (state: IPromoState, action) => {
        state.imagesIsLoading = false;
        state.imagesError = action.payload as string;
      });
  },
});

export const promoReducer = promoSlice.reducer;
